import { Extension } from "@tiptap/core"
import { Plugin, PluginKey } from "@tiptap/pm/state"

export const DetailsClickHandlerExtension = Extension.create({
	name: "detailsClickHandler",

	addProseMirrorPlugins() {
		return [
			new Plugin({
				key: new PluginKey("detailsClickHandler"),
				props: {
					handleDOMEvents: {
						mousedown(view, event) {
							if (event.button !== 0) return false

							const target = event.target as HTMLElement
							const summary = target.closest("summary.details-summary")
							if (!summary) return false

							const detailsWrapper = summary.closest('div[data-type="details"]')
							if (!detailsWrapper) return false

							const toggleButton = detailsWrapper.querySelector("button")
							if (!toggleButton) return false

							const isEditable = view.editable

							if (isEditable) {
								const summaryRect = summary.getBoundingClientRect()
								const clickX = event.clientX - summaryRect.left

								const beforeWidth = 40
								const isClickingBefore = clickX <= beforeWidth

								if (!isClickingBefore) {
									return false
								}
							}

							event.preventDefault()
							event.stopPropagation()

							toggleButton.click()

							return true
						},
					},
				},
			}),
		]
	},
})
